module.exports = __webpack_public_path__ + "static/img/default-avatar.91a79324.svg";